// @flow
import React from "react"
import { connect } from "react-redux"
import cookie from "js-cookie"
import NitroHeaderLinks from "@kiwicom/nitro/lib/components/HeaderLinks"
import { Consumer as IntlConsumer } from "@kiwicom/nitro/lib/services/intl/context"
import { Consumer as CurrencyConsumer } from "@kiwicom/nitro/lib/services/currency/context"
import type {
  SearchForm,
  HeaderLinksContext,
} from "@kiwicom/nitro/lib/components/HeaderLinks/records/HeaderLink"

import { splitsterSelector } from "common/services/utils/splitsterSelector"

type OwnProps = {|
  searchForm?: SearchForm | null,
  newDesign: boolean,
  inverted: boolean,
|}
type StateProps = {|
  splitster: {
    getSaveResults: (value: boolean) => { [key: string]: string },
  },
  brandId: HeaderLinksContext,
|}
type Props = {|
  ...OwnProps,
  ...StateProps,
|}

function saveSplitster({ splitster }) {
  Object.keys(splitster).forEach(key => {
    cookie.set(key, splitster[key])
  })
}

const HeaderLinks = ({ searchForm, splitster, inverted, newDesign }: Props) => (
  <IntlConsumer>
    {({ language }) => (
      <CurrencyConsumer>
        {({ currency }) => (
          <NitroHeaderLinks
            active="travel"
            context="booking"
            newDesign={newDesign}
            currencyId={currency.id}
            languageId={language.id}
            // $FlowFixMe: TODO
            searchForm={(searchForm && searchForm.toJS()) || null}
            splitster={splitster.getSaveResults(true)}
            inverted={inverted}
            onFetch={saveSplitster}
          />
        )}
      </CurrencyConsumer>
    )}
  </IntlConsumer>
)

HeaderLinks.defaultProps = {
  searchForm: null,
  inverted: false,
}

// $FlowFixMe TODO: plz add type when updating
export default connect(state => ({
  splitster: splitsterSelector(state),
}))(HeaderLinks)
